(() => {
    const PREF_KEY = 'tmf_pdp_preference';
    const FLOW_KEY = 'tmf_commercial_flow';

    const style = document.createElement('style');
    style.textContent = `
      button[data-quotify]{
        position:relative;
        transition:opacity .2s ease;
      }

      button[data-quotify].is-loading{
        pointer-events:none;
        opacity:.75;
        color:transparent !important;
      }

      button[data-quotify].is-loading::after{
        content:"";
        position:absolute;
        top:50%;
        left:50%;
        width:18px;
        height:18px;
        margin:-9px 0 0 -9px;
        border:2px solid rgba(255,255,255,.35);
        border-top-color:#fff;
        border-radius:50%;
        animation:quotify-spinner .8s linear infinite;
      }

      @keyframes quotify-spinner{
        to{
          transform:rotate(360deg);
        }
      }

      @media (prefers-reduced-motion: reduce){
        button[data-quotify].is-loading::after{
          animation:none;
          border-color:#fff;
        }
      }

      .quotify-sticky-cart-btn{
        position:fixed !important;
        left:-9999px !important;
        top:0 !important;
        width:1px !important;
        height:1px !important;
        margin:0 !important;
        padding:0 !important;
        opacity:0 !important;
        pointer-events:none !important;
        overflow:hidden !important;
      }

      .quotify-sticky-cart-btn.tmf-quotify-cart-armed{
        left:0 !important;
        top:0 !important;
        width:auto !important;
        height:auto !important;
        pointer-events:auto !important;
        z-index:-1 !important;
      }

      html.tmf-commercial-cart .header__icon--cart:not(.header__icon--quote-cart){
        display:none !important;
      }

      html:not(.tmf-commercial-cart) .header__icon--quote-cart{
        display:none !important;
      }
    `;

    document.head.appendChild(style);

    let activeButton = null;
    let observerAttached = false;

    function isCommercialMode() {
      const html = document.documentElement;
      if (html.getAttribute('data-tmf-commercial-template') === 'true') return true;
      try {
        if (sessionStorage.getItem(PREF_KEY) === 'commercial') return true;
        if (sessionStorage.getItem(FLOW_KEY) === '1') return true;
      } catch (e) {}
      return false;
    }

    function syncHeaderCartMode() {
      document.documentElement.classList.toggle('tmf-commercial-cart', isCommercialMode());
    }

    function resetButton() {
      if (!activeButton) return;

      activeButton.disabled = false;
      activeButton.classList.remove('is-loading');
      activeButton = null;
    }

    function observeIframe() {
      if (observerAttached) return;

      const iframe = document.getElementById('quotify-frame');

      if (!iframe) {
        setTimeout(observeIframe, 100);
        return;
      }

      observerAttached = true;

      new MutationObserver(() => {
        const hidden =
          getComputedStyle(iframe).display === 'none' ||
          iframe.src === 'about:blank';

        if (hidden) {
          resetButton();
        }
      }).observe(iframe, {
        attributes: true,
        attributeFilter: ['style', 'src']
      });
    }

    observeIframe();

    function getQuotifyCartButton() {
      return document.querySelector('button.quotify-sticky-cart-btn[data-quotify-cart]');
    }

    function openQuotifyCart(retries) {
      const opener = getQuotifyCartButton();

      if (!opener) {
        if (retries > 0) setTimeout(function () {
          openQuotifyCart(retries - 1);
        }, 50);
        return;
      }

      opener.classList.add('tmf-quotify-cart-armed');

      const eventInit = { bubbles: true, cancelable: true, view: window };
      opener.dispatchEvent(new PointerEvent('pointerdown', eventInit));
      opener.dispatchEvent(new MouseEvent('mousedown', eventInit));
      opener.dispatchEvent(new PointerEvent('pointerup', eventInit));
      opener.dispatchEvent(new MouseEvent('mouseup', eventInit));
      opener.dispatchEvent(new MouseEvent('click', eventInit));
      opener.click();

      requestAnimationFrame(function () {
        opener.classList.remove('tmf-quotify-cart-armed');
      });
    }

    function getCartCount() {
      const counter = document.querySelector(
        'button.quotify-sticky-cart-btn [data-quotify-cart-count]'
      );
      if (!counter) return 0;

      const text = (counter.textContent || '').trim();
      if (!text || text.indexOf(':count') !== -1) return 0;

      const match = text.match(/\d+/);
      if (!match) return 0;

      const count = parseInt(match[0], 10);
      return Number.isFinite(count) ? count : 0;
    }

    function syncQuoteCartCount() {
      const count = getCartCount();

      document.querySelectorAll('[data-tmf-quote-cart-count]').forEach((bubble) => {
        const visible = bubble.querySelector('[aria-hidden="true"]');
        const sr = bubble.querySelector('.visually-hidden');

        if (visible) {
          visible.textContent = count < 100 ? String(count) : '';
        }

        if (sr) {
          const label = sr.getAttribute('data-count-template');
          sr.textContent = label ? label.replace('0', String(count)) : String(count);
        }
      });
    }

    let syncScheduled = false;

    function scheduleQuoteCartSync() {
      if (syncScheduled) return;

      syncScheduled = true;
      requestAnimationFrame(() => {
        syncScheduled = false;
        syncHeaderCartMode();
        syncQuoteCartCount();
      });
    }

    syncHeaderCartMode();
    syncQuoteCartCount();

    new MutationObserver(scheduleQuoteCartSync).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('click', (e) => {
      const headerTrigger = e.target.closest('[data-tmf-quote-cart]');
      if (headerTrigger) {
        e.preventDefault();
        openQuotifyCart(20);
        return;
      }

      const button = e.target.closest('button[data-quotify]');
      if (!button) return;

      if (button.classList.contains('is-loading')) {
        e.preventDefault();
        return;
      }

      activeButton = button;
      button.disabled = true;
      button.classList.add('is-loading');
    });

    document.addEventListener(
      'click',
      (e) => {
        if (!isCommercialMode()) return;
        const retailCart = e.target.closest(
          '.header__icon--cart:not(.header__icon--quote-cart)'
        );
        if (!retailCart) return;
        e.preventDefault();
        e.stopPropagation();
      },
      true
    );
  })();
